<div class="bannerMessageBg" #bannerMessagePopup style="display: none;">
  <div [ngStyle]="{'margin-top': dynamicHeightOfBanner ? dynamicHeightOfBanner + 'px' : 0}">
    <div class="informationIcon">
      <img src="../../../../assets/images/alpha-icons/icons-information.svg" class="iconsinformation">
    </div>
    <div class="informationMssage">
      <span class="notification-text">
        <span *ngIf="termsAndConditions === true; else show" >
          <span class="condition-text" (click)="isDisplayConditions = !isDisplayConditions">View Terms & Conditions&nbsp;
            <img *ngIf="isDisplayConditions" src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,2180,27,10))'" />
            <img *ngIf="!isDisplayConditions" src="../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,2210,27,10))'" />
          </span><br>
          <span *ngIf="isDisplayConditions">{{message}} <a href="{{termsAndConditionsUrl}}" target="_blank" rel="noopener noreferrer">Terms and Conditions </a>
          </span>
        </span>
        <ng-template #show>
          {{
            (message && messageType == 'object' && arrayOfKeys.indexOf(selectedData) > -1) ? 
              message[selectedData]['msg']  :  (message && messageType == 'object') ? 
              message['defaultMsg']['msg']  : (message && messageType == 'string') ? message : createOrderBanner
          }}
          <span class="msgBtnStyle" *ngIf="(message && messageType == 'object')" (click)="opePopup(message[selectedData])">
            {{
              (arrayOfKeys.indexOf(selectedData) > -1 && message[selectedData]['isButton']) ? 
              message[selectedData]['hyperLinkName'] : 
              (arrayOfKeys['defaultMsg'] > -1 && message['defaultMsg']['isButton']) ?  
              message['defaultMsg']['hyperLinkName'] :  ''
            }}
          </span>
        </ng-template>
      </span>
    </div>
    <div class="informationClose" (click)="closeBannerPopupFn()"></div>
  </div>
  </div>
  <div style="height: 50px;" #bannerDiv id="bannerId"></div>
